module Meevo.Plugins.Client {
    let pattern = Meevo.Components.Common.Constants.REGEX_EMAIL_VALIDATOR;

    export class EmailSearchStrategy extends ClientSearchStrategyBase implements IClientSearchStrategy {

        get valid(): boolean {
            return typeof this.model.emailAddress === 'string' && pattern.test(this.model.emailAddress);
        }

        search(options?: any): ng.IPromise<Model.Client[]> {
            if (!this.valid) {
                return;
            }

            const criteria = {
                email: this.model.emailAddress,
                isForceGlobal: !this.appSettings.APP_BUSINFOSETTINGS.clientsSettings.localClientSearchOnly
            };

            return this.dataService.getListPaged('client', {criteria})
        }

        showWarning(modalService: Meevo.Components.Modal.IModalService, clients: Model.Client[]): ng.IPromise<any> {
            var customOptions: Meevo.Components.Modal.ILocalOptions = {
                showCancelButton: true,
                cancelButtonContentKey: "LABEL_NO_GO_TO_EXISTING_PROFILE"
            };

            return modalService.confirm("WARNING_DUPLICATE_CLIENT_EMAIL",
                                        Meevo.Components.Modal.ModalTranslationModes.Translate,
                                        false,
                                        customOptions,
                                        true)
                .then((response: boolean) => {
                    if (!response) {
                        // if user clicks on negative action
                        return clients[0].id;
                    }
                });

        }
    }
}
